import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["picker"]

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    this.pickerTarget.classList.toggle("d-none")
  }

  close() {
    this.pickerTarget.classList.add("d-none")
  }

  select(event) {
    this.pickerTarget.classList.add("d-none")
  }
}
